"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// @future/index.ts
var future_exports = {};
__export(future_exports, {
  Highcharts: () => Highcharts,
  TimeRangeSelector: () => TimeRangeSelector
});
module.exports = __toCommonJS(future_exports);

// @future/Highcharts/Highcharts.tsx
var import_uik6 = require("@appd/uik");

// @future/Highcharts/MESSAGES.ts
var import_uik = require("@appd/uik");
var MESSAGES = {
  // (object-curly-newline)
  NO_DATA: import_uik.format.message`No data for this timeframe`.description("An indicator of there being no data in the chart.")
};

// @future/Highcharts/getCustomDefaults.tsx
var getCustomDefaults = /* @__PURE__ */ __name(({ noDataMessage = MESSAGES.NO_DATA() } = {}) => ({
  noDataMessage
}), "getCustomDefaults");

// @future/Highcharts/DEFAULTS.ts
var import_uik2 = require("@appd/uik");
var {
  COLORS: {
    ACCENT_A,
    ACCENT_B,
    ACCENT_C,
    ACCENT_D,
    ACCENT_F,
    ACCENT_G,
    ACCENT_H,
    ACCENT_I,
    ACCENT_J,
    DEFAULT_BORDER,
    DEFAULT_TEXT,
    DEFAULT_TEXT_STRONG,
    INTERACT_BG_WEAK_ACTIVE
  },
  TYPOGRAPHY: { HEADING_SUB_SECTION, P4_DEFAULT, WEIGHT_DEFAULT }
} = import_uik2.MAGNETIC_TOKENS;
var { FONT, GRID, POINT } = {
  FONT: {
    COLOR: {
      DEFAULT: DEFAULT_TEXT,
      STRONG: DEFAULT_TEXT_STRONG
    },
    DEFAULT: P4_DEFAULT
  },
  GRID: {
    COLOR: DEFAULT_BORDER,
    LINE_WIDTH: 1
  },
  POINT: {
    HOVER_COLOR: INTERACT_BG_WEAK_ACTIVE,
    LINE_WIDTH: 4,
    RADIUS_PLUS: 3
  }
};
var DEFAULTS = {
  colors: [ACCENT_A, ACCENT_B, ACCENT_C, ACCENT_D, ACCENT_F, ACCENT_G, ACCENT_H, ACCENT_I, ACCENT_J],
  legend: {
    align: "left",
    itemStyle: {
      color: FONT.COLOR.DEFAULT,
      font: FONT.DEFAULT,
      fontWeight: WEIGHT_DEFAULT
    }
  },
  plotOptions: {
    area: {
      marker: {
        enabled: false,
        lineColor: POINT.HOVER_COLOR,
        states: {
          hover: {
            lineWidth: POINT.LINE_WIDTH,
            radiusPlus: POINT.RADIUS_PLUS
          }
        }
      }
    },
    line: {
      marker: {
        enabled: false,
        lineColor: POINT.HOVER_COLOR,
        states: {
          hover: {
            lineWidthPlus: POINT.LINE_WIDTH,
            radiusPlus: POINT.RADIUS_PLUS
          }
        }
      }
    }
  },
  title: {
    align: "left",
    style: { font: HEADING_SUB_SECTION },
    text: void 0
  },
  xAxis: {
    crosshair: { width: 2 },
    gridLineColor: GRID.COLOR,
    gridLineWidth: GRID.LINE_WIDTH,
    labels: {
      style: {
        color: FONT.COLOR.STRONG,
        font: FONT.DEFAULT
      }
    },
    lineWidth: 0,
    tickColor: GRID.COLOR,
    title: {
      style: {
        color: FONT.COLOR.STRONG,
        font: FONT.DEFAULT
      }
    }
  },
  yAxis: {
    gridLineColor: GRID.COLOR,
    gridLineWidth: GRID.LINE_WIDTH,
    labels: {
      style: {
        color: FONT.COLOR.STRONG,
        font: FONT.DEFAULT
      }
    },
    tickColor: GRID.COLOR,
    title: {
      style: {
        color: FONT.COLOR.STRONG,
        font: FONT.DEFAULT
      }
    }
  }
};

// @future/Highcharts/getOptionDefaults.tsx
var getOptionDefaults = /* @__PURE__ */ __name((options = {}) => merge(DEFAULTS, options), "getOptionDefaults");
var merge = /* @__PURE__ */ __name((srcObj, newObj) => {
  const result = { ...srcObj };
  for (let key in newObj) {
    result[key] = replace(result[key], newObj[key]);
  }
  return result;
}, "merge");
var replace = /* @__PURE__ */ __name((srcValue, newValue) => {
  if (typeof srcValue === "object" && srcValue !== null && typeof newValue === "object" && newValue !== null) {
    return merge(srcValue, newValue);
  }
  return newValue;
}, "replace");

// @future/Highcharts/getStyles.tsx
var import_uik3 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER, DEFAULT_BG, DEFAULT_BG_WEAK, DEFAULT_TEXT_MEDIUM },
  RADIUS,
  SPACING,
  TYPOGRAPHY: { P3_DEFAULT, P4_DEFAULT: P4_DEFAULT2 }
} = import_uik3.MAGNETIC_TOKENS;
var DASH_STYLES = {
  ShortDash: [2, 2],
  Solid: "none"
};
var getStyles = /* @__PURE__ */ __name(({ isEmpty, isNull }) => ({
  CHART: (0, import_uik3.css)({
    ...AREA,
    ...AXIS,
    ...GRIDLINES,
    ...TOOLTIP,
    "& .highcharts-credits": { display: "none" },
    "& .highcharts-halo": { fillOpacity: 0 },
    display: isEmpty || isNull ? "none" : "block"
  }),
  NO_DATA: (0, import_uik3.css)({
    backgroundColor: DEFAULT_BG,
    borderRadius: RADIUS.DEFAULT,
    color: DEFAULT_TEXT_MEDIUM,
    display: "flex",
    font: P3_DEFAULT,
    justifyContent: "center",
    padding: SPACING[3],
    textAlign: "center"
  })
}), "getStyles");
var AREA = { "& .highcharts-area-series .highcharts-area": { opacity: 0.2 } };
var AXIS = { "& .highcharts-xaxis-labels": { transform: `translateY(${SPACING[2]}px)` } };
var GRIDLINES = {
  "& .highcharts-grid-line, & .highcharts-xaxis .highcharts-axis-line": { strokeDasharray: DASH_STYLES["ShortDash"] },
  "& .highcharts-tick": { strokeDasharray: DASH_STYLES["ShortDash"] },
  "& .highcharts-xaxis-grid .highcharts-grid-line": { strokeDasharray: DASH_STYLES["ShortDash"] },
  "& .highcharts-yaxis-grid .highcharts-grid-line": { strokeDasharray: DASH_STYLES["ShortDash"] }
};
var TOOLTIP = {
  "& .highcharts-tooltip": {
    "& > .highcharts-tooltip-box": {
      fill: DEFAULT_BG_WEAK,
      stroke: CONTROL_BORDER,
      strokeWidth: 2
    },
    font: P4_DEFAULT2
  }
};

// @future/Highcharts/useChart.ts
var import_uik5 = require("@appd/uik");
var import_react2 = require("react");

// HIGHCHARTS/HIGHCHARTS.ts
var import_uik4 = require("@appd/uik");
var import_react = require("react");

// HIGHCHARTS/SHAPES.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var SHAPES = {
  BASELINE: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.2, x: 0.1, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.2, x: 0.4, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.2, x: 0.7, y: 0.4 })
  ] }),
  CIRCLE: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { cx: 0.5, cy: 0.5, r: 0.5 }) }),
  DIAMOND: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "polygon",
    {
      points: [
        [0.5, 0],
        [1, 0.5],
        [0.5, 1],
        [0, 0.5]
      ].join(" ")
    }
  ) }),
  PENTAGON: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "polygon",
    {
      points: [...Array(5).keys()].map(
        (i) => [
          0.5 + 0.5 * Math.cos((i * -72 + 90) * Math.PI / 180),
          0.5 - 0.5 * Math.sin((i * -72 + 90) * Math.PI / 180)
        ].map((t) => +t.toFixed(6))
      ).join(" ")
    }
  ) }),
  PERCENTILE: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.2, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.4, x: 0.3, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.2, width: 0.2, x: 0.8, y: 0.4 })
  ] }),
  SQUARE: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 1, width: 1, x: 0, y: 0 }) }),
  TREND: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { height: 0.1, width: 0.7, y: 0.45 }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "polygon",
      {
        points: [
          [0.7, 0.35],
          [1, 0.5],
          [0.7, 0.65]
        ].join(" ")
      }
    )
  ] }),
  TRIANGLE: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "polygon",
    {
      points: [
        [0.5, 0],
        [1, 1],
        [0, 1]
      ].join(" ")
    }
  ) }),
  TRIANGLE_DOWN: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "polygon",
    {
      points: [
        [0, 0],
        [1, 0],
        [0.5, 1]
      ].join(" ")
    }
  ) }),
  // Keep in sync with `PENTAGON` above.
  registerPentagon: (SVGRenderer) => {
    SVGRenderer.prototype.symbols.pentagon ??= (x, y, w, h) => [
      ...[...Array(5).keys()].map(
        (i) => [
          x + w * (0.5 + 0.5 * Math.cos((i * -72 + 90) * Math.PI / 180)),
          y + h * (0.5 - 0.5 * Math.sin((i * -72 + 90) * Math.PI / 180))
        ].map((t) => +t.toFixed(6))
      ).flatMap(([x2, y2], i) => [i === 0 ? "M" : "L", x2, y2]),
      "z"
    ];
  }
};

// HIGHCHARTS/HIGHCHARTS.ts
var HIGHCHARTS = /* @__PURE__ */ __name(() => RESOLVED() ?? void LOAD.then(RESOLVED.set), "HIGHCHARTS");
HIGHCHARTS.SHAPES = SHAPES;
HIGHCHARTS.use = () => {
  const [, rerender] = (0, import_react.useReducer)(() => true, false);
  (0, import_react.useEffect)(() => RESOLVED.subscribe(rerender), []);
  return HIGHCHARTS();
};
var LOAD = import_uik4.utils.CAN_USE_DOM ? import_uik4.utils.lazyPromise(async () => {
  const [_, highstock, more, solidGauge] = await Promise.all([
    import("highcharts"),
    import("highcharts/highstock"),
    import("highcharts/highcharts-more"),
    import("highcharts/modules/solid-gauge")
  ]);
  more.default(highstock);
  solidGauge.default(highstock);
  SHAPES.registerPentagon(highstock.SVGRenderer);
  if (import_uik4.utils.IS_JEST) {
    SVGElement.prototype.getBBox ??= () => ({
      height: 0,
      width: 0,
      x: 0,
      y: 0
    });
  }
  return highstock;
}) : (
  // Don't fetch on server due to errors like
  // TypeError: Cannot read properties of undefined (reading 'Core/Chart/Chart.js')
  new Promise(() => {
  })
);
var RESOLVED = import_uik4.utils.mutable(void 0);

// @future/Highcharts/useChart.ts
var useChart = /* @__PURE__ */ __name(({ options }) => {
  const [chartRef, setChartRef] = (0, import_react2.useState)(null);
  const ref = (0, import_react2.useRef)(null);
  const fontsReady = import_uik5.utils.useFontsReady();
  const Highcharts2 = HIGHCHARTS.use();
  const dependencies = [chartRef, fontsReady, Highcharts2, ref.current, options, setChartRef];
  (0, import_react2.useEffect)(() => {
    const { current: container } = ref;
    if (!container || !fontsReady || !Highcharts2) {
      return;
    }
    if (!chartRef) {
      setChartRef(Highcharts2.chart(container, options));
    } else {
      chartRef.update(
        options,
        /* redraw */
        true,
        /* oneToOne */
        true,
        /* animation */
        true
      );
    }
    return import_uik5.Measurer.subscribe(container, () => chartRef?.reflow());
  }, dependencies);
  return {
    chartRef: (
      // Invalidate referential identity whenever `useEffect` retriggers, by using the same `dependencies`.
      (0, import_react2.useMemo)(
        () => ({
          get current() {
            return chartRef;
          }
        }),
        dependencies
      )
    ),
    ref
  };
}, "useChart");

// @future/Highcharts/Highcharts.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Highcharts = Object.assign(
  import_uik6.utils.forwardRef(({ className, custom, options = {}, ...inherited }, forwardedRef) => {
    const customWithDefaults = getCustomDefaults(custom);
    const optionsWithDefaults = getOptionDefaults(options);
    const { chartRef, ref } = useChart({ options: optionsWithDefaults });
    const isNull = chartRef == null;
    const isEmpty = Boolean(chartRef?.current && chartRef?.current?.yAxis[0]?.max == void 0);
    const { CHART, NO_DATA } = getStyles({
      isEmpty,
      isNull
    });
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { ref: forwardedRef, uik: "Highcharts", ...inherited, children: [
      isEmpty && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: (0, import_uik6.css)(NO_DATA), children: customWithDefaults?.noDataMessage }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: (0, import_uik6.css)(CHART, ...import_uik6.utils.many(className)), ref })
    ] });
  }),
  {}
);
Highcharts.displayName = "Highcharts";
Highcharts.__DEV_METADATA__ = { status: "READY" };

// @future/TimeRangeSelector/TimeRangeSelector.tsx
var import_uik18 = require("@appd/uik");
var import_react9 = require("react");

// @future/TimeRangeSelector/Provider.tsx
var import_react3 = require("react");
var import_jsx_runtime3 = require("react/jsx-runtime");
var Provider = /* @__PURE__ */ __name(({ children }) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(CONTEXT.Provider, { value: { url: globalThis.window?.location.pathname ?? "" }, children }), "Provider");
var CONTEXT = (0, import_react3.createContext)({ url: globalThis.window?.location.pathname ?? "" });
Provider.CONTEXT = CONTEXT;
Provider.displayName = "TimeRangeSelector.Provider";

// @future/TimeRangeSelector/Refresh/Refresh.tsx
var import_uik10 = require("@appd/uik");
var import_luxon7 = require("luxon");
var import_react4 = require("react");

// @future/TimeRangeSelector/Refresh/getStyles.ts
var import_uik7 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_WEAK,
    CONTROL_BG_WEAK_DISABLED,
    CONTROL_BORDER: CONTROL_BORDER2,
    CONTROL_BORDER_DISABLED,
    CONTROL_BORDER_HOVER,
    CONTROL_ICON_WEAK,
    DEFAULT_TEXT: DEFAULT_TEXT2,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM2,
    DEFAULT_TEXT_WEAK_DISABLED,
    INVERSE_BG,
    INVERSE_BORDER,
    INVERSE_ICON,
    INVERSE_ICON_DISABLED,
    INVERSE_TEXT
  },
  RADIUS: RADIUS2,
  SPACING: SPACING2,
  TYPOGRAPHY: { ELLIPSES, P4_DEFAULT: P4_DEFAULT3 }
} = import_uik7.MAGNETIC_TOKENS;
var getStyles2 = /* @__PURE__ */ __name((disabled, loading, lightTheme) => ({
  AUTO_REFRESH_HEADING: (0, import_uik7.css)({
    color: DEFAULT_TEXT_MEDIUM2,
    font: P4_DEFAULT3,
    padding: "9px 16px",
    textAlign: "center"
  }),
  AUTO_REFRESH_MENU_TRIGGER: (0, import_uik7.css)({
    ...disabled ? {
      backgroundColor: lightTheme ? CONTROL_BG_WEAK_DISABLED : INVERSE_BG,
      border: `2px solid ${CONTROL_BORDER_DISABLED}`,
      color: lightTheme ? DEFAULT_TEXT_WEAK_DISABLED : INVERSE_ICON_DISABLED,
      cursor: "not-allowed"
    } : {
      "&:hover": { border: `2px solid ${CONTROL_BORDER_HOVER}` },
      backgroundColor: lightTheme ? CONTROL_BG_WEAK : INVERSE_BG,
      border: `2px solid ${CONTROL_BORDER2}`,
      color: lightTheme ? DEFAULT_TEXT2 : INVERSE_TEXT,
      cursor: "pointer"
    },
    borderBottomRightRadius: "6px",
    borderLeft: "none",
    borderTopRightRadius: "6px",
    boxSizing: "border-box",
    display: "flex",
    outline: "none",
    padding: "4px 8px",
    ...ELLIPSES.END,
    alignItems: "center",
    gap: SPACING2[2],
    justifyContent: "center",
    userSelect: "none"
  }),
  AUTO_REFRESH_POPOVER_CONTENT: (0, import_uik7.css)({
    border: `2px solid ${CONTROL_BORDER2}`,
    boxShadow: "none",
    left: "-9px",
    marginBlock: SPACING2[1],
    maxWidth: "106px",
    padding: 0,
    position: "relative",
    width: "106px"
  }),
  LOADING_ANIMATION: (0, import_uik7.css)({
    "& path": { fill: lightTheme ? CONTROL_ICON_WEAK : INVERSE_ICON },
    animationDelay: "-0.1s",
    animationDuration: "1.2s",
    animationIterationCount: "infinite",
    animationName: {
      from: { transform: "rotate(0)" },
      to: { transform: "rotate(360deg)" }
    },
    animationTimingFunction: "cubic-bezier(0.5, 0, 0.5, 1)",
    opacity: disabled ? 0.38 : 1
  }),
  REFRESH: (0, import_uik7.css)({
    ...disabled ? {
      backgroundColor: lightTheme ? CONTROL_BG_WEAK_DISABLED : INVERSE_BG,
      border: `2px solid ${CONTROL_BORDER_DISABLED}`,
      color: lightTheme ? DEFAULT_TEXT_WEAK_DISABLED : INVERSE_ICON_DISABLED,
      cursor: "not-allowed"
    } : {
      ...!loading && {
        "&:hover": { border: `2px solid ${CONTROL_BORDER_HOVER}` },
        cursor: "pointer"
      },
      backgroundColor: lightTheme ? CONTROL_BG_WEAK : INVERSE_BG,
      border: `2px solid ${CONTROL_BORDER2}`
    },
    alignItems: "center",
    borderBottomLeftRadius: "6px",
    borderRight: "none",
    borderTopLeftRadius: "6px",
    boxSizing: "border-box",
    display: "flex",
    outline: "none",
    padding: "4px 8px",
    ...ELLIPSES.END,
    justifyContent: "center",
    userSelect: "none"
  }),
  REFRESH_DIVIDER: (0, import_uik7.css)({
    height: 34,
    width: 2,
    ...disabled ? { backgroundColor: lightTheme ? CONTROL_BORDER_DISABLED : INVERSE_BORDER } : {}
  }),
  REFRESH_DIVIDER_WRAPPER: (0, import_uik7.css)({
    ...disabled ? { backgroundColor: lightTheme ? CONTROL_BG_WEAK_DISABLED : INVERSE_BG } : { backgroundColor: lightTheme ? CONTROL_BG_WEAK : INVERSE_BG },
    alignItems: "center",
    display: "flex",
    height: "100%"
  }),
  REFRESH_WRAPPER: (0, import_uik7.css)({
    "& > div": { backgroundColor: lightTheme ? CONTROL_BORDER2 : INVERSE_BORDER },
    "&:hover": { "& > div": { backgroundColor: CONTROL_BORDER_HOVER } },
    alignItems: "center",
    borderRadius: RADIUS2.HEAVY,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    marginLeft: SPACING2[3]
  })
}), "getStyles");

// @future/TimeRangeSelector/MESSAGES.ts
var MESSAGES_exports = {};
__export(MESSAGES_exports, {
  AGO: () => AGO,
  APPLY: () => APPLY,
  AUTO_REFRESH: () => AUTO_REFRESH,
  AUTO_REFRESH_INTERVAL_OFF: () => AUTO_REFRESH_INTERVAL_OFF,
  CUSTOM: () => CUSTOM,
  CUSTOM_TYPE: () => CUSTOM_TYPE,
  DEFAULT: () => DEFAULT,
  DESCRIPTION: () => DESCRIPTION,
  FROM: () => FROM,
  LEARN_MORE_TEXT: () => LEARN_MORE_TEXT,
  NOW: () => NOW,
  RECENTLY_USED: () => RECENTLY_USED,
  REQUIRED_NUMBER_ERROR: () => REQUIRED_NUMBER_ERROR,
  TIMEZONE: () => TIMEZONE,
  TO: () => TO,
  UNITS: () => UNITS,
  VALIDATION_TIMERANGE_ERROR: () => VALIDATION_TIMERANGE_ERROR
});
var import_uik8 = require("@appd/uik");
var APPLY = import_uik8.format.message`Apply time range`.description(
  "A button that applies the custom time range to the selected time range."
);
var AUTO_REFRESH = import_uik8.format.message`Auto Refresh`.description(
  "A label shown in dropdown menu of TimeRangeSelector for choosing between different automatic refresh intervals ('Off', '1m', '5m', '15m')."
);
var AUTO_REFRESH_INTERVAL_OFF = import_uik8.format.message`Off`.description("Auto Refresh Off label");
var CUSTOM = import_uik8.format.message`Custom`.description("Custom time ranges");
var CUSTOM_TYPE = import_uik8.format.message`${{
  ABSOLUTE: "Absolute",
  NOW: "Now",
  RELATIVE: "Relative"
}}`.description("Custom time range type");
var UNITS = import_uik8.format.message`${{
  DAYS: "days",
  HOURS: "hours",
  MINUTES: "minutes",
  WEEKS: "weeks"
}}`.description("");
var AGO = import_uik8.format.message`${"$0"} ago`.description("ago message");
var NOW = import_uik8.format.message`now`.description("now time string");
var DEFAULT = import_uik8.format.message`Default`.description("Default time ranges");
var DESCRIPTION = import_uik8.format.message`If auto refresh is on, the refresh rate controls how current the displayed data is.`.description(
  "Description TImeRange"
);
var FROM = import_uik8.format.message`From`.description("Indicates the start point of the custom time range");
var LEARN_MORE_TEXT = import_uik8.format.message`Learn more about Time Range Selector`.description(
  "Learn more about Time range selector link"
);
var RECENTLY_USED = import_uik8.format.message`Recently used`.description("Recently used section");
var REQUIRED_NUMBER_ERROR = import_uik8.format.message`Enter a number`.description(
  "Error message for required validation on input type number"
);
var TIMEZONE = import_uik8.format.message`Time zone`.description("Timezone label");
var TO = import_uik8.format.message`To`.description("Indicates the end point of the custom time range.");
var VALIDATION_TIMERANGE_ERROR = import_uik8.format.message`This time range is not possible. Please ensure “From” time is before “To” time.`.description(
  "validation message for timerange"
);

// @future/TimeRangeSelector/util.ts
var import_uik9 = require("@appd/uik");
var import_luxon6 = require("luxon");

// @future/TimeRangeSelector/TimeRange/isEqualInput.ts
var import_luxon = require("luxon");
function isEqualInput(a, b) {
  if (a === b) {
    return true;
  } else if (a === void 0 || b === void 0) {
    return false;
  } else {
    const isSinceEqual = import_luxon.Duration.fromISO(a.since).equals(import_luxon.Duration.fromISO(b.since)) || a.since === b.since;
    let isUntilEqual = a.until === b.until;
    if (a.until && b.until && !isUntilEqual) {
      isUntilEqual = import_luxon.Duration.fromISO(a.until).equals(import_luxon.Duration.fromISO(b.until));
    }
    return isSinceEqual && isUntilEqual;
  }
}
__name(isEqualInput, "isEqualInput");

// @future/TimeRangeSelector/TimeRange/isEqualValue.ts
function isEqualValue(a, b) {
  if (a === b) {
    return true;
  }
  return a === void 0 || b === void 0 ? false : isEqualInput(a.input, b.input) && a.now === b.now;
}
__name(isEqualValue, "isEqualValue");

// @future/TimeRangeSelector/TimeRange/isValid.ts
var import_luxon2 = require("luxon");
var isValid = /* @__PURE__ */ __name((timeRangeValue) => {
  const { since: normalizeSince, until: normalizeUntil } = normalizeInput(timeRangeValue.input);
  if (normalizeSince && (isRelativeInputPart(normalizeSince) && !import_luxon2.Duration.fromISO(normalizeSince).isValid || !isRelativeInputPart(normalizeSince) && !import_luxon2.DateTime.fromISO(normalizeSince).isValid)) {
    return false;
  }
  if (normalizeUntil && (isRelativeInputPart(normalizeUntil) && !import_luxon2.Duration.fromISO(normalizeUntil).isValid || !isRelativeInputPart(normalizeUntil) && !import_luxon2.DateTime.fromISO(normalizeUntil).isValid)) {
    return false;
  }
  const resolved = TimeRange.resolve(timeRangeValue);
  return !(resolved.since >= resolved.until);
}, "isValid");

// @future/TimeRangeSelector/TimeRange/resolve.ts
var import_luxon3 = require("luxon");
var resolve = /* @__PURE__ */ __name(({ input, now }) => {
  const { since, until } = normalizeInput(input);
  return {
    since: resolvePart(since, now),
    until: resolvePart(until, now)
  };
}, "resolve");
function resolvePart(part, now) {
  if (part === void 0) {
    return now;
  }
  if (part.startsWith("P") || part.startsWith("-P")) {
    return import_luxon3.DateTime.fromISO(now, { zone: "UTC" }).plus(import_luxon3.Duration.fromISO(part)).toISO();
  }
  return part;
}
__name(resolvePart, "resolvePart");

// @future/TimeRangeSelector/TimeRange/toLegacy.tsx
var import_luxon4 = require("luxon");
var toLegacy = /* @__PURE__ */ __name((input) => ({
  since: toLegacyInputPart(input.since),
  until: toLegacyInputPart(input.until)
}), "toLegacy");
function toLegacyInputPart(part) {
  if (part === void 0) {
    return void 0;
  }
  if (part.startsWith("P") || part.startsWith("-P")) {
    let duration = normalizeDuration(import_luxon4.Duration.fromISO(part));
    const uqlDuration = UNITS2.map((unit) => ({
      unit: UNITS_UQE_MAP[unit],
      value: Math.round(Math.abs(duration[unit]))
    })).filter(({ value }) => value !== 0).map(({ unit, value }) => `${value}${unit}`).join("");
    const sign = uqlDuration.length === 0 ? "" : duration.toMillis() < 0 ? "-" : "+";
    return `now${sign}${uqlDuration}`;
  }
  return part;
}
__name(toLegacyInputPart, "toLegacyInputPart");
var UNITS2 = ["weeks", "days", "hours", "minutes"];
var UNITS_UQE_MAP = {
  days: "d",
  hours: "h",
  minutes: "m",
  weeks: "w"
};
function normalizeDuration(duration) {
  const object = duration.toObject();
  if (!Object.keys(object).every((unit) => UNITS2.includes(unit))) {
    return duration.shiftTo(...UNITS2);
  }
  if (!Object.values(object).every((value) => Number.isSafeInteger(value))) {
    return duration.shiftTo(...UNITS2);
  }
  const values = Object.entries(object).map(([, value = 0]) => Math.sign(value)).filter((value) => value !== 0);
  if (values.length !== Math.abs(values.reduce((a, b) => a + b, 0))) {
    return duration.shiftTo(...UNITS2);
  }
  return duration;
}
__name(normalizeDuration, "normalizeDuration");

// @future/TimeRangeSelector/TimeRange/valueFromSearchParams.tsx
var import_luxon5 = require("luxon");
function valueFromSearchParams(searchParams, {
  excludeNow = false,
  nowParam = "now",
  param = "t",
  sinceParam = "since",
  untilParam = "until"
} = {}) {
  if (searchParams === void 0) {
    return void 0;
  }
  if (searchParams.has(param)) {
    const split = decodeURIComponent(searchParams.get(param) ?? "").split("_", 3);
    const since = parseSinceOrUntil(split.at(0) ?? "");
    if (since === void 0) {
      return void 0;
    }
    const until = parseSinceOrUntil(split.at(1) ?? "");
    const now = parseNow(split.at(2) ?? "") ?? (/* @__PURE__ */ new Date()).toISOString();
    return {
      input: {
        since,
        until
      },
      now
    };
  }
  if (searchParams.has(sinceParam)) {
    const since = parseSinceOrUntil(decodeURIComponent(searchParams.get(sinceParam) ?? ""));
    if (since === void 0) {
      return void 0;
    }
    const until = parseSinceOrUntil(decodeURIComponent(searchParams.get(untilParam) ?? ""));
    const now = (excludeNow ? void 0 : parseNow(decodeURIComponent(searchParams.get(nowParam) ?? ""))) ?? (/* @__PURE__ */ new Date()).toISOString();
    return {
      input: {
        since,
        until
      },
      now
    };
  }
  return void 0;
}
__name(valueFromSearchParams, "valueFromSearchParams");
function parseSinceOrUntil(rawSinceOrUntil) {
  if (rawSinceOrUntil === "") {
    return void 0;
  }
  const sinceOrUntilEpoch = import_luxon5.DateTime.fromMillis(Number(rawSinceOrUntil), { zone: "UTC" });
  if (sinceOrUntilEpoch.isValid) {
    return sinceOrUntilEpoch.toISO();
  }
  const sinceOrUntilUql = parseUqlSinceOrUntil(rawSinceOrUntil);
  if (sinceOrUntilUql.isValid) {
    return sinceOrUntilUql.toMillis() === 0 ? void 0 : formatRelativeDuration(sinceOrUntilUql);
  }
  if (rawSinceOrUntil.startsWith("P") || rawSinceOrUntil.startsWith("-P")) {
    const sinceOrUntilDuration = import_luxon5.Duration.fromISO(rawSinceOrUntil);
    return sinceOrUntilDuration.isValid ? formatRelativeDuration(sinceOrUntilDuration) : void 0;
  }
  const sinceOrUntil = import_luxon5.DateTime.fromISO(rawSinceOrUntil, { zone: "UTC" });
  if (!sinceOrUntil.isValid) {
    return void 0;
  }
  return sinceOrUntil.toISO();
}
__name(parseSinceOrUntil, "parseSinceOrUntil");
function parseNow(rawNow) {
  if (rawNow === "") {
    return void 0;
  }
  const now = import_luxon5.DateTime.fromISO(rawNow, { zone: "UTC" });
  if (!now.isValid) {
    return void 0;
  }
  return now.toISO();
}
__name(parseNow, "parseNow");

// @future/TimeRangeSelector/TimeRange/valueToLegacySearchParams.tsx
function valueToLegacySearchParams(timeRange, {
  excludeNow = false,
  nowParam = "now",
  sinceParam = "since",
  untilParam = "until"
} = {}) {
  const searchParams = new URLSearchParams();
  if (timeRange === void 0) {
    return searchParams;
  }
  searchParams.set(sinceParam, timeRange.input.since);
  if (timeRange.input.until !== void 0) {
    searchParams.set(untilParam, timeRange.input.until);
  }
  if (!excludeNow) {
    searchParams.set(nowParam, timeRange.now);
  }
  return searchParams;
}
__name(valueToLegacySearchParams, "valueToLegacySearchParams");

// @future/TimeRangeSelector/TimeRange/valueToSearchParams.tsx
function valueToSearchParams(value, { excludeNow = false, param = "t" } = {}) {
  const searchParams = new URLSearchParams();
  if (value === void 0) {
    return searchParams;
  }
  const serialized = [value.input.since, value.input.until ?? "", excludeNow ? "" : value.now].join("_");
  searchParams.set(param, serialized);
  return searchParams;
}
__name(valueToSearchParams, "valueToSearchParams");

// @future/TimeRangeSelector/TimeRange/TimeRange.tsx
var TimeRange = {
  isEqualInput,
  isEqualValue,
  isValid,
  resolve,
  toLegacy,
  valueFromSearchParams,
  valueToLegacySearchParams,
  valueToSearchParams
};

// @future/TimeRangeSelector/util.ts
function normalizeInput(input) {
  const since = parseUqlSinceOrUntil(input.since);
  const until = parseUqlSinceOrUntil(input.until);
  return {
    since: since.isValid ? formatRelativeDuration(since) : input.since,
    until: until.isValid ? until.toMillis() === 0 ? void 0 : formatRelativeDuration(until) : input.until
  };
}
__name(normalizeInput, "normalizeInput");
var UQE_PART_REGEX = /^\s*now\s*(([+-])\s*((?<weeks>[0-9]+)w)?((?<days>[0-9]+)d)?((?<hours>[0-9]+)h)?((?<minutes>[0-9]+)m)?\s*)?$/;
function parseUqlSinceOrUntil(rawSinceOrUntil) {
  if (rawSinceOrUntil === void 0) {
    return import_luxon6.Duration.invalid("Undefined");
  }
  const result = UQE_PART_REGEX.exec(rawSinceOrUntil);
  if (result === null) {
    return import_luxon6.Duration.invalid("Format");
  }
  if (result[1] === void 0) {
    return import_luxon6.Duration.fromMillis(0);
  }
  const duration = import_luxon6.Duration.fromObject(result.groups);
  return result[2] === "-" ? duration.negate() : duration;
}
__name(parseUqlSinceOrUntil, "parseUqlSinceOrUntil");
function formatInput(input, presets, style = "short") {
  const title = presets?.find(
    (preset) => preset.title !== void 0 && TimeRange.isEqualInput(preset.input, input)
  )?.title;
  if (title !== void 0) {
    return [title];
  }
  return [
    formatInputPart(input.since, style, false),
    formatInputPart(
      input.until,
      style,
      input.until !== void 0 && import_luxon6.DateTime.fromISO(input.since).toISODate() === import_luxon6.DateTime.fromISO(input.until).toISODate()
    )
  ];
}
__name(formatInput, "formatInput");
function formatInputPart(part, style, timeOnly) {
  if (part === void 0) {
    return NOW();
  }
  if (part.startsWith("P") || part.startsWith("-P")) {
    return AGO(import_uik9.format.duration(import_luxon6.Duration.fromISO(part).negate().toISO(), { unitDisplay: "long" }));
  }
  return timeOnly ? import_uik9.format.time(part) : import_uik9.format.dateTime[style](part);
}
__name(formatInputPart, "formatInputPart");
function isRelativeInput(input) {
  return isRelativeInputPart(input.since) || isRelativeInputPart(input.until);
}
__name(isRelativeInput, "isRelativeInput");
function isRelativeInputPart(part) {
  return part === void 0 || part.startsWith("P") || part.startsWith("-P");
}
__name(isRelativeInputPart, "isRelativeInputPart");
function formatRelativeDuration(duration) {
  return duration.toMillis() < 0 ? `-${duration.negate().toISO()}` : duration.toISO();
}
__name(formatRelativeDuration, "formatRelativeDuration");

// @future/TimeRangeSelector/Refresh/Refresh.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var Refresh = /* @__PURE__ */ __name(({ lightTheme, onChange, showLoading, value }) => {
  const [visible, setVisible] = (0, import_react4.useState)(false);
  const [selected, setSelected] = (0, import_react4.useState)(0);
  const duration = OPTIONS[selected];
  const triggerRef = (0, import_react4.useRef)(null);
  const overlayRef = (0, import_react4.useRef)(null);
  const isRelative = (0, import_react4.useMemo)(() => isRelativeInput(value.input), [value]);
  const { url } = (0, import_react4.useContext)(Provider.CONTEXT);
  const [pathname, setPathname] = (0, import_react4.useState)(url);
  if (url !== pathname) {
    setPathname(url);
    setSelected(0);
  }
  (0, import_react4.useEffect)(() => {
    if (!isRelative || !duration.isValid || showLoading) {
      return;
    }
    const timeout = window.setTimeout(() => {
      onChange(
        {
          input: value.input,
          now: (/* @__PURE__ */ new Date()).toISOString()
        },
        "AUTO_REFRESH"
      );
    }, duration.toMillis());
    return () => clearTimeout(timeout);
  }, [duration, value, showLoading, isRelative]);
  import_uik10.utils.useLayoutEffect(() => {
    if (visible) {
      setTimeout(() => import_uik10.utils.focusFirst(overlayRef));
    } else if (overlayRef.current?.contains(document.activeElement)) {
      triggerRef.current?.focus();
    }
  }, [visible]);
  const {
    AUTO_REFRESH_HEADING,
    AUTO_REFRESH_MENU_TRIGGER,
    AUTO_REFRESH_POPOVER_CONTENT,
    LOADING_ANIMATION,
    REFRESH,
    REFRESH_DIVIDER,
    REFRESH_DIVIDER_WRAPPER,
    REFRESH_WRAPPER
  } = getStyles2(!isRelative, showLoading, lightTheme);
  const content = isRelative && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
    "div",
    {
      onKeyUp: (event) => {
        if (event.key === "Escape") {
          setVisible(false);
        }
      },
      ref: overlayRef,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: AUTO_REFRESH_HEADING, children: AUTO_REFRESH() }),
        /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          import_uik10.Menu.List,
          {
            onSelect: ([index]) => {
              setVisible(!visible);
              setSelected(index);
            },
            selected: [selected],
            children: OPTIONS.map((duration2, index) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik10.Menu.Option, { children: formatOption(duration2) }, index))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: REFRESH_WRAPPER, uik: "TimeRangeSelector.Refresh", children: [
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      "button",
      {
        className: REFRESH,
        disabled: !isRelative || showLoading,
        onClick: () => onChange(
          {
            input: value.input,
            now: (/* @__PURE__ */ new Date()).toISOString()
          },
          "REFRESH"
        ),
        children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          import_uik10.Icon,
          {
            className: (0, import_uik10.css)(showLoading && LOADING_ANIMATION, !isRelative && { opacity: 0.38 }),
            fill: lightTheme ? CONTROL_ICON_WEAK2 : INVERSE_ICON2,
            type: showLoading ? "Status.AppNotResponding" : duration.isValid ? "Action.AutoRefresh" : "Action.Refresh"
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: REFRESH_DIVIDER_WRAPPER, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: REFRESH_DIVIDER }) }),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      import_uik10.Popover,
      {
        arrow: false,
        content,
        contentClassName: AUTO_REFRESH_POPOVER_CONTENT,
        onVisibleChange: setVisible,
        position: "BOTTOM",
        trigger: "CLICK",
        visible,
        children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
          "button",
          {
            className: AUTO_REFRESH_MENU_TRIGGER,
            disabled: !isRelative,
            onClick: (e) => {
              e.stopPropagation();
              setVisible((visible2) => !visible2);
            },
            ref: triggerRef,
            children: [
              duration.isValid && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { children: formatOption(duration) }),
              /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                import_uik10.Icon.Navigation.ArrowDropDown,
                {
                  className: (0, import_uik10.css)(!isRelative && { opacity: 0.38 }),
                  fill: lightTheme ? CONTROL_ICON_WEAK2 : INVERSE_ICON2
                }
              )
            ]
          }
        )
      }
    )
  ] });
}, "Refresh");
var {
  COLORS: { CONTROL_ICON_WEAK: CONTROL_ICON_WEAK2, INVERSE_ICON: INVERSE_ICON2 }
} = import_uik10.MAGNETIC_TOKENS;
var { AUTO_REFRESH_INTERVAL_OFF: AUTO_REFRESH_INTERVAL_OFF2 } = MESSAGES_exports;
var OPTIONS = [
  import_luxon7.Duration.invalid("Off"),
  import_luxon7.Duration.fromISO("PT1M"),
  import_luxon7.Duration.fromISO("PT5M"),
  import_luxon7.Duration.fromISO("PT15M")
];
function formatOption(duration) {
  return duration.isValid ? duration.toHuman({ unitDisplay: "narrow" }) : AUTO_REFRESH_INTERVAL_OFF2();
}
__name(formatOption, "formatOption");

// @future/TimeRangeSelector/Selector.tsx
var import_uik17 = require("@appd/uik");
var import_react8 = require("react");

// @future/TimeRangeSelector/Footer.tsx
var import_uik12 = require("@appd/uik");
var import_luxon8 = require("luxon");

// @future/TimeRangeSelector/STYLES.ts
var import_uik11 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BORDER: CONTROL_BORDER3,
    CONTROL_BORDER_WEAK,
    DEFAULT_TEXT: DEFAULT_TEXT3,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM3,
    INTERACT_TEXT,
    NEGATIVE_ICON,
    NEGATIVE_TEXT
  },
  RADIUS: RADIUS3,
  SPACING: SPACING3,
  TYPOGRAPHY: { P4_DEFAULT: P4_DEFAULT4, P4_EMPHASIS }
} = import_uik11.MAGNETIC_TOKENS;
var WIDTH = 799;
var STYLES = {
  DATETIME_PICKER_CONTAINER: (0, import_uik11.css)({ padding: "8px 0" }),
  DESCRIPTION: (0, import_uik11.css)({
    color: DEFAULT_TEXT_MEDIUM3,
    font: P4_DEFAULT4,
    padding: "8px 0"
  }),
  ERROR: (0, import_uik11.css)({
    "& .icon": {
      "& path": { fill: NEGATIVE_ICON },
      marginRight: SPACING3[1]
    },
    alignItems: "center",
    color: NEGATIVE_TEXT,
    display: "flex",
    paddingBottom: SPACING3[3]
  }),
  FOOTER: (0, import_uik11.css)({
    "& .learn-more": {
      color: INTERACT_TEXT,
      font: P4_EMPHASIS,
      textDecoration: "none"
    },
    "& .timezone-label": {
      color: DEFAULT_TEXT3,
      font: P4_EMPHASIS,
      marginRight: SPACING3[2]
    },
    "& .timezone-text": { color: DEFAULT_TEXT_MEDIUM3 },
    alignItems: "center",
    borderTop: "1px solid",
    borderTopColor: CONTROL_BORDER_WEAK,
    display: "flex",
    justifyContent: "space-between",
    padding: "9px 9px",
    zIndex: 2
  }),
  HR: (0, import_uik11.css)({
    borderTop: "1px solid",
    borderTopColor: CONTROL_BORDER_WEAK,
    marginBottom: 3,
    marginTop: 3
  }),
  INPUT_CONTAINER: (0, import_uik11.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    width: "100%"
  }),
  INPUT_HEADING: (0, import_uik11.css)({
    color: DEFAULT_TEXT_MEDIUM3,
    font: P4_DEFAULT4,
    padding: SPACING3[4]
  }),
  INPUT_RADIO_SECTION: (0, import_uik11.css)({
    display: "flex",
    flexDirection: "column",
    gap: SPACING3[2],
    padding: "8px 0"
  }),
  INPUT_TIME_CONTENT: (0, import_uik11.css)({
    "& .section-label": {
      color: DEFAULT_TEXT3,
      font: P4_EMPHASIS
    },
    padding: "0 16px"
  }),
  MENU_OPTION: (0, import_uik11.css)({ padding: `0 ${SPACING3[4]}px` }),
  POPOVER: (0, import_uik11.css)({
    marginBlock: SPACING3[1],
    maxWidth: WIDTH,
    width: WIDTH
  }),
  POPOVER_CONTENT: (0, import_uik11.css)({
    border: `2px solid ${CONTROL_BORDER3}`,
    borderRadius: RADIUS3.HEAVY,
    boxShadow: "none",
    boxSizing: "border-box",
    maxWidth: WIDTH,
    overflow: "unset",
    padding: 0,
    width: WIDTH
  }),
  RADIO_CONTAINER: (0, import_uik11.css)({
    alignItems: "center",
    display: "flex",
    gap: SPACING3[3],
    marginLeft: "-6px"
  }),
  SELECTION_HEADING: (0, import_uik11.css)({
    color: DEFAULT_TEXT_MEDIUM3,
    font: P4_DEFAULT4,
    padding: "6px 10px 6px 10px"
  })
};

// @future/TimeRangeSelector/Footer.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Footer = /* @__PURE__ */ __name(() => {
  const timeZone = import_luxon8.DateTime.local().toFormat("ZZZZZ");
  const timeZoneAbbr = timeZone.split(" ").map(([first]) => first).join("");
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: (0, import_uik12.css)(FOOTER, (0, import_uik12.css)({ gridArea: "footer" })), children: [
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "timezone-label", children: TIMEZONE() }),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("span", { className: "timezone-text", children: [
        timeZone,
        " - ",
        timeZoneAbbr
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("a", { className: "learn-more", href: LEARN_MORE_ABOUT_TIME_RANGE_URL, target: "_blank", children: LEARN_MORE_TEXT() })
  ] });
}, "Footer");
var LEARN_MORE_ABOUT_TIME_RANGE_URL = "https://docs.appdynamics.com/pages/viewpage.action?pageId=206966655&scmLanguageKey=en";
var { FOOTER } = STYLES;

// @future/TimeRangeSelector/Input.tsx
var import_uik13 = require("@appd/uik");
var import_luxon9 = require("luxon");
var import_react5 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
var Input = /* @__PURE__ */ __name(({ displayFormat, onChange, value }) => {
  const [{ since, until, valid }, dispatch] = (0, import_react5.useReducer)(
    (prev, { since: since2, until: until2, valid: valid2 = true }) => ({
      since: {
        ...prev.since,
        ...since2
      },
      until: {
        ...prev.until,
        ...until2
      },
      valid: valid2
    }),
    void 0,
    () => ({
      since: toStatePart(value.input.since, value.now),
      until: toStatePart(value.input.until, value.now),
      valid: TimeRange.isValid(value)
    })
  );
  (0, import_react5.useEffect)(() => {
    dispatch({
      since: toStatePart(value.input.since, value.now),
      until: toStatePart(value.input.until, value.now),
      valid: TimeRange.isValid(value)
    });
  }, [value]);
  const submitHandler = /* @__PURE__ */ __name((_, errors) => {
    if (errors.length) {
      dispatch({ valid: false });
      return;
    }
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const nextValue = {
      input: {
        since: toInputPart(since) ?? now,
        until: toInputPart(until)
      },
      now
    };
    const resolved = TimeRange.resolve(nextValue);
    if (resolved.since >= resolved.until) {
      dispatch({ valid: false });
      return;
    }
    onChange(nextValue, "INPUT");
  }, "submitHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
    import_uik13.ScrollBox,
    {
      className: (0, import_uik13.css)({
        gridArea: "input",
        height: "100%"
      }),
      uik: "TimeRangeSelector.Input",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: SELECTION_HEADING, children: CUSTOM() }),
        /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(import_uik13.Form, { className: INPUT_TIME_CONTENT, onSubmit: submitHandler, children: [
          /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: INPUT_RADIO_SECTION, children: [
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "section-label", children: FROM() }),
            /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
              import_uik13.Radio.Group,
              {
                className: RADIO_CONTAINER,
                onChange: (kind) => dispatch({ since: { kind } }),
                value: since.kind,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Radio, { label: CUSTOM_TYPE("RELATIVE"), value: "RELATIVE" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Radio, { label: CUSTOM_TYPE("ABSOLUTE"), value: "ABSOLUTE" })
                ]
              }
            )
          ] }),
          since.kind === "RELATIVE" && /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: INPUT_CONTAINER, children: [
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
              import_uik13.Input,
              {
                className: (0, import_uik13.css)({ width: 80 }),
                errors: since.value ? [] : [REQUIRED_NUMBER_ERROR()],
                min: 1,
                onChange: ({ currentTarget: { value: value2 } }) => dispatch({ since: { value: value2 } }),
                type: "number",
                value: since.value
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
              import_uik13.Select,
              {
                className: (0, import_uik13.css)({ width: 257 }),
                onChange: ([index]) => dispatch({ since: { unit: UNIT_OPTIONS[index].unit } }),
                required: true,
                value: [UNIT_OPTIONS.findIndex((option) => option.unit === since.unit)],
                children: UNIT_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Select.Option, { children: option.title }, option.title))
              }
            )
          ] }),
          since.kind === "ABSOLUTE" && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: DATETIME_PICKER_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
            import_uik13.DateTimePicker,
            {
              className: (0, import_uik13.css)({ width: 230 }),
              displayFormat,
              onTimestampChange: (timestamp) => dispatch({ since: { timestamp } }),
              overlay: true,
              required: true,
              timestamp: since.timestamp
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: INPUT_RADIO_SECTION, children: [
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "section-label", children: TO() }),
            /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
              import_uik13.Radio.Group,
              {
                className: RADIO_CONTAINER,
                onChange: (kind) => dispatch({ until: { kind } }),
                value: until.kind,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Radio, { label: CUSTOM_TYPE("RELATIVE"), value: "RELATIVE" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Radio, { label: CUSTOM_TYPE("ABSOLUTE"), value: "ABSOLUTE" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Radio, { label: CUSTOM_TYPE("NOW"), value: "NOW" })
                ]
              }
            )
          ] }),
          until.kind === "RELATIVE" && /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: INPUT_CONTAINER, children: [
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
              import_uik13.Input,
              {
                className: (0, import_uik13.css)({ width: 80 }),
                errors: until.value ? [] : [REQUIRED_NUMBER_ERROR()],
                min: 1,
                onChange: ({ currentTarget: { value: value2 } }) => dispatch({ until: { value: value2 } }),
                type: "number",
                value: until.value
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
              import_uik13.Select,
              {
                className: (0, import_uik13.css)({ width: 257 }),
                onChange: ([index]) => dispatch({ until: { unit: UNIT_OPTIONS[index].unit } }),
                required: true,
                value: [UNIT_OPTIONS.findIndex((option) => option.unit === until.unit)],
                children: UNIT_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Select.Option, { children: option.title }, option.title))
              }
            )
          ] }),
          until.kind === "ABSOLUTE" && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: DATETIME_PICKER_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
            import_uik13.DateTimePicker,
            {
              className: (0, import_uik13.css)({ width: 230 }),
              displayFormat,
              onTimestampChange: (timestamp) => dispatch({ until: { timestamp } }),
              overlay: true,
              required: true,
              timestamp: until.timestamp
            }
          ) }),
          !valid && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Banner, { onClose: "DISABLE", type: "ERROR", children: VALIDATION_TIMERANGE_ERROR() }),
          valid && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: STYLES.DESCRIPTION, children: DESCRIPTION() }),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: (0, import_uik13.css)({ padding: "8px 0" }), children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_uik13.Button, { type: "SUBMIT", children: APPLY() }) })
        ] })
      ]
    }
  );
}, "Input");
var UNITS3 = ["weeks", "days", "hours", "minutes"];
function toStatePart(part, now) {
  if (part === void 0) {
    return {
      kind: "NOW",
      timestamp: new Date(now).getTime(),
      unit: "minutes",
      value: "1"
    };
  }
  const [kind, timestamp, duration] = part.startsWith("P") || part.startsWith("-P") ? [
    "RELATIVE",
    import_luxon9.DateTime.fromISO(now).plus(import_luxon9.Duration.fromISO(part)).toMillis(),
    normalizeDuration2(import_luxon9.Duration.fromISO(part))
  ] : ["ABSOLUTE", new Date(part).getTime(), import_luxon9.DateTime.fromISO(part).diffNow([...UNITS3])];
  const filteredUnits = UNITS3.filter((unit) => duration[unit] !== 0);
  if (filteredUnits.length === 0) {
    return {
      kind,
      timestamp,
      unit: "minutes",
      value: "0"
    };
  }
  if (filteredUnits.length === 1) {
    return {
      kind,
      timestamp,
      unit: filteredUnits[0],
      value: String(Math.round(-duration[filteredUnits[0]]))
    };
  }
  for (const unit of UNITS3) {
    if (Math.abs(duration.as(unit)) >= 1) {
      return {
        kind,
        timestamp,
        unit,
        value: String(Math.round(-duration.as(unit)))
      };
    }
  }
  return {
    kind,
    timestamp,
    unit: "minutes",
    value: String(-Math.sign(duration.as("minutes")))
  };
}
__name(toStatePart, "toStatePart");
function normalizeDuration2(duration) {
  const object = duration.toObject();
  if (!Object.keys(object).every((unit) => UNITS3.includes(unit))) {
    return duration.shiftTo(...UNITS3);
  }
  const values = Object.entries(object).map(([, value = 0]) => Math.sign(value)).filter((value) => value !== 0);
  if (values.length !== Math.abs(values.reduce((a, b) => a + b, 0))) {
    return duration.shiftTo(...UNITS3);
  }
  return duration;
}
__name(normalizeDuration2, "normalizeDuration");
function toInputPart(part) {
  if (part.kind === "NOW") {
    return void 0;
  }
  if (part.kind === "ABSOLUTE") {
    return new Date(part.timestamp).toISOString();
  }
  return `-${import_luxon9.Duration.fromObject({ [part.unit]: Number(part.value) }).toISO()}`;
}
__name(toInputPart, "toInputPart");
var {
  DATETIME_PICKER_CONTAINER,
  INPUT_CONTAINER,
  INPUT_RADIO_SECTION,
  INPUT_TIME_CONTENT,
  RADIO_CONTAINER,
  SELECTION_HEADING
} = STYLES;
var UNIT_OPTIONS = UNITS3.map((unit) => ({
  title: UNITS(unit.toUpperCase()),
  unit
}));

// @future/TimeRangeSelector/Presets.tsx
var import_uik14 = require("@appd/uik");
var import_jsx_runtime7 = require("react/jsx-runtime");
var Presets = /* @__PURE__ */ __name(({ onChange, presets }) => /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: PRESET_CONTENT, uik: "TimeRangeSelector.Preset", children: [
  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: SELECTION_HEADING2, children: DEFAULT() }),
  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_uik14.ScrollBox, { className: (0, import_uik14.css)({ flexGrow: 1 }), children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    import_uik14.Menu.List,
    {
      onSelect: ([index]) => onChange(
        {
          input: presets[index].input,
          now: (/* @__PURE__ */ new Date()).toISOString()
        },
        "PRESET"
      ),
      selected: [],
      children: presets.map((preset, index) => /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_uik14.Menu.Option, { className: MENU_OPTION, children: preset.title ?? formatInput(preset.input).join("\u2009\u2013\u2009") }, index))
    }
  ) })
] }), "Presets");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK2 }
} = import_uik14.MAGNETIC_TOKENS;
var PRESET_CONTENT = (0, import_uik14.css)({
  borderRight: "1px solid",
  borderRightColor: CONTROL_BORDER_WEAK2,
  boxSizing: "border-box",
  display: "flex",
  flexFlow: "column",
  gridArea: "presets",
  height: "100%",
  overflow: "hidden"
});
var { MENU_OPTION, SELECTION_HEADING: SELECTION_HEADING2 } = STYLES;

// @future/TimeRangeSelector/Recents.tsx
var import_uik15 = require("@appd/uik");
var import_react6 = require("react");
var import_jsx_runtime8 = require("react/jsx-runtime");
var Recents = /* @__PURE__ */ __name(({ onChange, presets, recents }) => {
  const exclusiveRecents = (0, import_react6.useMemo)(
    () => recents.filter((recent) => !presets.some((preset) => TimeRange.isEqualInput(preset.input, recent.input))),
    [presets, recents]
  );
  if (exclusiveRecents.length === 0) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    "div",
    {
      className: (0, import_uik15.css)({
        borderRight: "1px solid",
        borderRightColor: CONTROL_BORDER_WEAK3,
        display: "flex",
        flexFlow: "column",
        gridArea: "recents",
        height: 190
      }),
      uik: "TimeRangeSelector.Recent",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: HR }),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: SELECTION_HEADING3, children: RECENTLY_USED() }),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_uik15.ScrollBox, { className: { flexGrow: 1 }, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          import_uik15.Menu.List,
          {
            onSelect: ([index]) => onChange(
              {
                input: exclusiveRecents[index].input,
                now: (/* @__PURE__ */ new Date()).toISOString()
              },
              "RECENT"
            ),
            selected: [],
            children: exclusiveRecents.map((recent, index) => /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_uik15.Menu.Option, { className: MENU_OPTION2, children: formatInput(recent.input).join("\u2009\u2013\u2009") }, index))
          }
        ) })
      ]
    }
  );
}, "Recents");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK3 }
} = import_uik15.MAGNETIC_TOKENS;
var { HR, MENU_OPTION: MENU_OPTION2, SELECTION_HEADING: SELECTION_HEADING3 } = STYLES;

// @future/TimeRangeSelector/Trigger.tsx
var import_uik16 = require("@appd/uik");
var import_luxon10 = require("luxon");
var import_react7 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
var Trigger = import_uik16.utils.forwardRef(
  ({ disabled, lightTheme, onClick, presets, value, ...props }, ref) => {
    const [since, until] = (0, import_react7.useMemo)(() => formatInput(value.input, presets), [value, presets]);
    const tooltip = (0, import_react7.useMemo)(() => {
      const timeZoneAbbr = import_luxon10.DateTime.local().toFormat("ZZZZZ").split(" ").map(([first]) => first).join("");
      const range = formatInput(TimeRange.resolve(value), void 0, "longWithWeekday").join("\u2009\u2013\u2009");
      return `${range} ${timeZoneAbbr}`;
    }, [value]);
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_uik16.Tooltip, { value: tooltip, children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
      "button",
      {
        className: (0, import_uik16.css)(
          {
            "&:hover": { border: `2px solid ${CONTROL_BORDER_HOVER2}` },
            all: void 0,
            ...ELLIPSES2.END,
            alignItems: "center",
            backgroundColor: lightTheme ? CONTROL_BG_WEAK2 : INVERSE_BG2,
            border: `2px solid ${CONTROL_BORDER4}`,
            borderRadius: RADIUS4.HEAVY,
            color: DEFAULT_TEXT4,
            cursor: "pointer",
            display: "flex",
            font: P4_DEFAULT5,
            gap: SPACING4[2],
            justifyContent: "center",
            paddingBlock: SPACING4[1],
            paddingInline: SPACING4[2],
            userSelect: "none"
          },
          disabled ? {
            backgroundColor: lightTheme ? CONTROL_BG_WEAK_DISABLED2 : INVERSE_BG2,
            color: lightTheme ? DEFAULT_TEXT_WEAK_DISABLED2 : INVERSE_ICON_DISABLED2,
            cursor: "not-allowed"
          } : {}
        ),
        disabled,
        onClick,
        ref,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_uik16.Icon.Object.Clock, { fill: lightTheme ? CONTROL_ICON_WEAK3 : INVERSE_ICON3, size: "SMALL" }),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: since }),
          until !== void 0 && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
              import_uik16.Icon.Navigation.ArrowRight,
              {
                className: (0, import_uik16.css)({ margin: `0 ${SPACING4[1]}` }),
                fill: lightTheme ? CONTROL_ICON_WEAK3 : INVERSE_ICON3,
                size: "SMALL"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: until })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_uik16.Icon.Navigation.ArrowDropDown, { fill: lightTheme ? CONTROL_ICON_WEAK3 : INVERSE_ICON3, size: "SMALL" })
        ]
      }
    ) });
  }
);
Trigger.displayName = "TimeRangeSelector.Trigger";
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK2,
    CONTROL_BG_WEAK_DISABLED: CONTROL_BG_WEAK_DISABLED2,
    CONTROL_BORDER: CONTROL_BORDER4,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER2,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK3,
    DEFAULT_TEXT: DEFAULT_TEXT4,
    DEFAULT_TEXT_WEAK_DISABLED: DEFAULT_TEXT_WEAK_DISABLED2,
    INVERSE_BG: INVERSE_BG2,
    INVERSE_ICON: INVERSE_ICON3,
    INVERSE_ICON_DISABLED: INVERSE_ICON_DISABLED2
  },
  RADIUS: RADIUS4,
  SPACING: SPACING4,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES2, P4_DEFAULT: P4_DEFAULT5 }
} = import_uik16.MAGNETIC_TOKENS;

// @future/TimeRangeSelector/Selector.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var Selector = /* @__PURE__ */ __name(({
  disabled,
  displayFormat,
  onChange: rawOnChange,
  presets,
  recents,
  triggerTheme,
  value
}) => {
  const [visible, setVisible] = (0, import_react8.useState)(false);
  const [inputValue, setInputValue] = (0, import_react8.useState)(value);
  const triggerRef = (0, import_react8.useRef)(null);
  const contentRef = (0, import_react8.useRef)(null);
  import_uik17.utils.useLayoutEffect(() => {
    if (visible) {
      setTimeout(() => import_uik17.utils.focusFirst(contentRef));
    } else if (contentRef.current?.contains(document.activeElement)) {
      triggerRef?.current?.focus();
    }
  }, [visible]);
  const onChange = /* @__PURE__ */ __name((nextValue, addToRecent) => {
    setInputValue(nextValue);
    if (!TimeRange.isValid(nextValue)) {
      return;
    }
    setVisible(false);
    rawOnChange(nextValue, addToRecent);
  }, "onChange");
  const { POPOVER, POPOVER_CONTENT } = STYLES;
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    import_uik17.Popover,
    {
      align: "END",
      arrow: false,
      className: POPOVER,
      content: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
        "div",
        {
          className: (0, import_uik17.css)({
            display: "inline-grid",
            grid: `
              " presets input   " 1fr
              " recents input   " min-content
              " footer  footer  " min-content
              / 383px   383px
            `,
            height: 494,
            padding: "15px 15px 5px 15px"
          }),
          onKeyUp: (event) => {
            if (event.key === "Escape") {
              setVisible(false);
            }
          },
          ref: contentRef,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Presets, { onChange, presets }),
            /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Recents, { onChange, presets, recents }),
            /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
              Input,
              {
                displayFormat,
                onChange,
                value: inputValue
              },
              `${value.input.since} ${value.input.until ?? ""}`
            ),
            /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Footer, {})
          ]
        }
      ),
      contentClassName: POPOVER_CONTENT,
      onVisibleChange: setVisible,
      position: "BOTTOM",
      visible,
      children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Trigger,
        {
          disabled,
          lightTheme: triggerTheme === "LIGHT",
          onClick: (e) => {
            e.stopPropagation();
            setVisible((visible2) => !visible2);
          },
          presets,
          ref: triggerRef,
          value
        }
      )
    }
  );
}, "Selector");

// @future/TimeRangeSelector/TimeRangeSelector.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var TimeRangeSelector = Object.assign(
  import_uik18.utils.forwardRef(
    ({
      className,
      disabled = false,
      displayFormat,
      hideRefresh = false,
      onSelectedTimeRangeChange,
      presets: rawPresets,
      recents: rawRecents,
      selectedTimeRange,
      showLoading = false,
      triggerTheme = "LIGHT",
      ...props
    }, ref) => {
      const [value, setValue] = useTimeRangeState(selectedTimeRange);
      const presets = useNormalizedPresets(rawPresets);
      const recents = useNormalizedRecents(rawRecents);
      const onChangeRef = (0, import_react9.useRef)(void 0);
      onChangeRef.current = onSelectedTimeRangeChange;
      const onChange = (0, import_react9.useCallback)((nextValue, eventSource) => {
        setValue(nextValue);
        onChangeRef.current?.({
          epoch: (/* @__PURE__ */ new Date()).toISOString(),
          eventSource,
          value: nextValue
        });
      }, []);
      return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
        "div",
        {
          className: (0, import_uik18.css)({ display: "flex" }, ...import_uik18.utils.many(className)),
          ref,
          uik: "TimeRangeSelector",
          ...props,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              Selector,
              {
                disabled,
                displayFormat,
                onChange,
                presets,
                recents,
                triggerTheme,
                value
              }
            ),
            !hideRefresh && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              Refresh,
              {
                lightTheme: triggerTheme === "LIGHT",
                onChange,
                showLoading,
                value
              }
            )
          ]
        }
      );
    }
  ),
  {
    Provider,
    TimeRange
  }
);
TimeRangeSelector.displayName = "TimeRangeSelector";
var INITIAL_VALUE = {
  input: { since: "-PT3H" },
  now: (/* @__PURE__ */ new Date()).toISOString()
};
function useTimeRangeState(selectedTimeRange) {
  const state = (0, import_react9.useState)(INITIAL_VALUE);
  const [value, setValue] = state;
  if (selectedTimeRange === void 0) {
    return state;
  }
  if (TimeRange.isEqualValue(selectedTimeRange, value)) {
    return state;
  }
  const normalizedValue = {
    // TODO phase out normalization
    input: normalizeInput(selectedTimeRange.input),
    now: selectedTimeRange.now
  };
  if (!TimeRange.isEqualValue(normalizedValue, value)) {
    setValue(normalizedValue);
  }
  return state;
}
__name(useTimeRangeState, "useTimeRangeState");
var DEFAULT_PRESETS = [];
function useNormalizedPresets(presets = DEFAULT_PRESETS) {
  return (0, import_react9.useMemo)(
    () => presets.map(
      (preset) => "input" in preset ? preset : {
        // TODO phase out normalization
        input: normalizeInput(preset),
        title: preset.title
      }
    ),
    [presets]
  );
}
__name(useNormalizedPresets, "useNormalizedPresets");
var DEFAULT_RECENTS = [];
function useNormalizedRecents(recents = DEFAULT_RECENTS) {
  return (0, import_react9.useMemo)(
    // TODO phase out normalization
    () => recents.map((recent) => "input" in recent ? recent : { input: normalizeInput(recent) }),
    [recents]
  );
}
__name(useNormalizedRecents, "useNormalizedRecents");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Highcharts,
  TimeRangeSelector
});
//# sourceMappingURL=uik.@future.js.map
